interface ClockWithChipInsideSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ClockWithChipInsideSVG = ({
  color,
  style,
}: ClockWithChipInsideSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="50"
    viewBox="0 0 40 50"
    fill="none"
  >
    <g clipPath="url(#clip0_768_10608)">
      <path
        d="M15.2266 5.66149C16.5928 4.78671 18.2047 4.2756 19.9445 4.2756C21.6842 4.2756 23.306 4.78671 24.6624 5.66149"
        stroke={color}
        strokeWidth="1.10085"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.8086 2.65382C14.8727 1.3269 17.3103 0.550415 19.9444 0.550415C22.5786 0.550415 25.026 1.3269 27.0803 2.65382"
        stroke={color}
        strokeWidth="1.10085"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.0273 8.25636C18.5778 7.90252 19.2363 7.68628 19.944 7.68628C20.6517 7.68628 21.3102 7.89269 21.8606 8.25636"
        stroke={color}
        strokeWidth="1.10085"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.6523 26.6169H26.0972"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6523 29.7326H26.0972"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6523 32.8386H26.0972"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.084 29.7326H14.5288"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.084 32.8386H14.5288"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6973 34.7946V36.2296"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5908 34.7946V36.2296"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4844 34.7946V36.2296"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6973 23.2259V24.6609"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5908 23.2259V24.6609"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9126 26.6169C18.9126 27.9929 17.7921 29.1134 16.416 29.1134V32.8288H22.6378V26.607H18.9224L18.9126 26.6169Z"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1129 20.0511C9.85951 22.2528 7.7168 25.9682 7.7168 30.1946C7.7168 36.9471 13.1915 42.4219 19.944 42.4219C26.6965 42.4219 32.1713 36.9471 32.1713 30.1946C32.1713 25.9583 30.0187 22.2233 26.7359 20.0216L13.1031 20.0511H13.1129Z"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.3236 43.9133C40.7126 36.5242 40.7126 24.5443 33.3236 17.1552C25.9345 9.76621 13.9546 9.76621 6.56553 17.1552C-0.82349 24.5443 -0.82349 36.5242 6.56553 43.9133C13.9546 51.3023 25.9345 51.3023 33.3236 43.9133Z"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6912 20.0413L38.6989 18.2524C39.4361 17.8101 39.5638 16.7977 38.9544 16.1883L36.8805 14.1144L34.8066 12.0405C34.1972 11.4311 33.1848 11.5589 32.7425 12.296L31.0225 15.1956"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.20919 20.0413L1.20152 18.2524C0.464346 17.8101 0.336569 16.7977 0.945965 16.1883L3.01988 14.1144L5.09379 12.0405C5.70319 11.4311 6.71557 11.5589 7.15788 12.296L8.88778 15.1956"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1697 12.355C24.1697 14.6845 22.2826 16.5815 19.9433 16.5815C17.604 16.5815 15.7168 14.6845 15.7168 12.355"
        stroke={color}
        strokeWidth="1.10085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_768_10608">
        <rect width="39.8958" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ClockWithChipInsideSVG;
